<template>
  <div class="content__actions">
    <div class="selector__content">
      <div class="selector__content__wrap">
        <div class="token-selector" @click="toggleDropdown">
          <div aria-expanded="false" class="selector-header" data-is_selector="true">
            <div class="selector-display" ref="selectToken">
              <span class="placeholder-tex" v-if="!selectedToken">选择货币</span>
              <div class="token-item" v-else>
                <img :src="selectedToken.img" class="token-img">
                <span class="selected-token ">{{selectedToken.name}}</span>
              </div>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-visible="false" class="css-1e9w5hk e1656iwc12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23178 9.35982C5.58534 8.93554 6.21591 8.87821 6.64018 9.23178L12 13.6983L17.3598 9.23178C17.7841 8.87821 18.4147 8.93554 18.7682 9.35982C19.1218 9.78409 19.0645 10.4147 18.6402 10.7682L12.6402 15.7682C12.2693 16.0773 11.7307 16.0773 11.3598 15.7682L5.35982 10.7682C4.93554 10.4147 4.87821 9.78409 5.23178 9.35982Z" fill="currentColor"></path>
            </svg>
          </div>
          <div class="dropdown-list">
            <ul role="listbox" aria-labelledby="downshift-0-label" :data-visible="shift_token" class="token-options ">
              <li v-for="(token, index) in tokens" :key="index" @click.stop="selectToken(token)" data-current="false" role="option" aria-selected="false" class="css-hgzbb6">
                <div class="token-item">
                  <img :src="token.img" class="token-img">
                  <span class="selected-token">{{ token.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div data-disabled="true" data-fetching="true" class="token-selector" @click="toggleNetworkDropdown">
          <div aria-expanded="false" class="selector-header" data-is_selector="true">
            <div class="selector-display">
              <span class="placeholder-tex" v-if="!selectedNetwork">选择网络</span>
              <span class="selected-token" v-else style="margin-left: 3vw">{{ selectedNetwork }}</span>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-visible="shift_token" class="css-1e9w5hk e1656iwc12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23178 9.35982C5.58534 8.93554 6.21591 8.87821 6.64018 9.23178L12 13.6983L17.3598 9.23178C17.7841 8.87821 18.4147 8.93554 18.7682 9.35982C19.1218 9.78409 19.0645 10.4147 18.6402 10.7682L12.6402 15.7682C12.2693 16.0773 11.7307 16.0773 11.3598 15.7682L5.35982 10.7682C4.93554 10.4147 4.87821 9.78409 5.23178 9.35982Z" fill="currentColor"></path>
            </svg>
          </div>
          <div class="dropdown-list">
            <ul role="listbox" :data-visible="shift_network" class="token-options" v-if="selectedToken?.networks">
              <li v-for="(network, index) in selectedToken.networks" :key="index" @click.stop="selectNetwork(network)" data-current="false" role="option" aria-selected="false" class="css-hgzbb6 e1656iwc8">
                <div class="token-item">
                  <span class="selected-token">{{ network.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between">
        <button :data-is_selector="network" class="btn primary large" @click="sendToken">继续付款</button>
        <button  class="btn primary large" :class="{'btn2': !network}" @click="this.$router.go(-1)" >取消</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cryptoSelection",
  props:["amount"],
  data(){
    return {
      shift_token:false,
      shift_network:false,
      selectedToken: null,
      selectedNetwork:null,
      selectedContract:null,
      selectNetworkProtocol:null,
      tokens: [
        { name: "USDT", img: require("@/assets/currencies/USDT.svg"), networks:[
            {name:"BSC (BEP-20)", protocol:2, contract: "https://bscscan.com/address/0x55d398326f99059ff775485246999027b3197955"},
            {name: "TRON (TRC-20)", protocol:3, contract: "https://tronscan.org/#/token20/TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t"},
            {name:"ETH (ERC-20)", protocol:1, contract: "https://etherscan.io/address/0xdac17f958d2ee523a2206206994597c13d831ec7"}
          ],
          network:null},
        // { name: "TRX", img: require("@/assets/currencies/TRX.svg"), networks: null, network:"TRON (TRC-20)" },
        // { name: "ETH", img: require("@/assets/currencies/ETH.svg"), networks: null, network:"ETH (ETC-20)" },
        // { name: "BNB", img: require("@/assets/currencies/BNB.svg"), networks: null, network:"BSC (BEP-20)" },
      ]
    }
  },
  methods:{
    toggleDropdown(){
      this.shift_network = false;
      this.shift_token = !this.shift_token
      console.log(this.shift_token)
    },
    selectToken(token) {
      this.selectedToken = token;
      this.toggleDropdown();
      this.selectedNetwork = this.selectedToken.network
    },
    selectNetwork(network) {
      this.selectedNetwork = network.name;
      this.selectNetworkProtocol = network.protocol
      this.selectedContract = network.contract
      this.shift_network = false;
    },
    toggleNetworkDropdown(){
      if (!this.selectedToken?.network && this.selectedToken?.networks) {
        this.shift_network = !this.shift_network
      }
    },
    async sendToken(){
      if (!this.selectedToken ||  !this.selectedNetwork){
        return false;
      }
      try {
        const res = await this.$user_http.post(`/user/createCryptoOrder?amount=${this.amount}&protocol=${this.selectNetworkProtocol}`);
        if (res.data?.code==0) {
          let token = res.data.data
          token.name=this.selectedToken.name
          token.network=this.selectedNetwork
          token.tokenAddress = res.data.data?.token
          token.contract = this.selectedContract
          this.$emit('token', token)
          return
        } else {
          console.error("获取视频列表失败：");
          console.log(res.data)
        }
      } catch (error) {
        console.error("获取视频列表失败：", error);
      }
    }
  },
  computed:{
    network(){
      return this.selectedNetwork?true:false
    }
  }
}
</script>

<style scoped lang="scss">
.content__actions {
  background-color: #ffffff;
  border-radius: 0 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px;
  .selector__content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    .selector__content__wrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .token-selector {
      display: flex;
      flex-direction: column;
      width: 100%;
      -webkit-box-pack: center;
      justify-content: center;
      align-self: center;
      position: relative;
      .selector-header[data-is_selector="true"] {
          cursor: pointer;
      }
      .selector-header {
        text-align: start;
        height: 60px;
        display: flex;
        align-items: center;
        border-radius: 12px;
        border: 1px solid #0000001a;
        color: #000;
        transition: 0.3s ease-in-out;
        .selector-display {
          flex-grow: 1;
          overflow: hidden;
        }
        .placeholder-tex {
          padding: 12px 16px;
          font-size: 16px;
          line-height: 24px;
          color: unset;
        }
        .css-1e9w5hk {
          margin-right: 16px;
          margin-left: 16px;
          width: 24px;
          height: 24px;
          color: var(--contentPrimary);
          flex-grow: 0;
          flex-shrink: 0;
          transition: transform 0.3s ease-in-out;
        }
      }
    }
    .dropdown-list {
      position: relative;
      width: 100%;
      .token-options {
        overflow: hidden auto;
        width: 100%;
        list-style: none;
        position: absolute;
        border-radius: 0px 0px 12px 12px;
        height: auto;
        max-height: 0px;
        transition: max-height 0.3s ease-in-out;
        background-color: #fff;
        z-index: 10;
        border-left: 1px solid #0000001a;
        border-right: 1px solid #0000001a;
        .search-box {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          gap: 8px;
          height: 48px;
          border-bottom: 1px solid #0000001a;
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
        }
        .css-hgzbb6 {
          height: 48px;
          display: flex;
          align-items: center;
          transition: 0.3s ease-in-out;
        }
      }
      .token-options[data-visible="true"] {
        max-height: 250px;
        border-bottom: 1px solid #0000001a;
        border-top: none;
      }
    }
    .token-img {
      width: 24px;
      height: 24px;
    }
    .token-item {
      display: flex;
      align-items: center;
      height: 48px;
      padding: 12px 16px;
      gap: 8px;
    }
  }
  .btn {
    height: 13.3vw;
    padding: 18px 24px;
    border-radius: 8px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    justify-content: center;
    line-height: 20px;
    width: 48%;
    cursor: pointer;
    transition: background-color 0.3s ease;
    &[data-is_selector="true"]{
      background-color: #000;
      color: #fff;
    }
  }
  .btn2{
    background-color: #000000;
    color: #fff
  }
}

@media only screen and (max-width: 460px) {
  .content__actions {
    border-radius: 0 !important;
    padding: 32px 16px !important;
  }
}
</style>
